import { render, staticRenderFns } from "./AlertWithDesc.vue?vue&type=template&id=b14b93fc&"
import script from "./AlertWithDesc.vue?vue&type=script&lang=js&"
export * from "./AlertWithDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports